import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CompartidoModule } from './librerias/compartido.module';
import { FiltroPipe } from './pipe/filtro.pipe';
import { PercentageDirective } from './percentage.directive';
import { CurrencyFormatDirective } from './currency-format.directive';
import { TieredMenuModule } from 'primeng/tieredmenu';


@NgModule({
  declarations: [AppComponent, FiltroPipe, PercentageDirective, CurrencyFormatDirective],
  imports: [
    TieredMenuModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CompartidoModule,
    FormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
